import { useNavigate } from 'react-router-dom';

import { useRegistrationRouteState } from '../features/registration/model';
import { RegistrationPhotoScreen } from '../features/registration/ui';

export function PhotoPage() {
  const navigate = useNavigate();
  const registrationRoute = useRegistrationRouteState();
  const nextPath = registrationRoute.nextImplementedPath;

  const continueToNextStep = () => {
    if (!nextPath) {
      return;
    }

    navigate(nextPath);
  };

  return (
    <RegistrationPhotoScreen
      onPhotoSelect={selectedPhoto => {
        navigate('/registration/photo/review', {
          state: { selectedPhoto },
        });
      }}
      onSkip={continueToNextStep}
    />
  );
}
